import useAPIService from '../common/useApiService';

export const useGetJobType = (id, params) => {
  const [getJobType, invokeGetJobType] = useAPIService(`job-types/${id}`, params);

  return [
    getJobType,
    invokeGetJobType
  ];
}